export default __webpack_public_path__ + "static/media/ltr_reports_ipad.4198e96d.png";